export const TEST_IDS = {
  // Header / nav
  header: "app-header",
  pingIndicator: "ping-indicator",
  navHome: "nav-home",
  navLobby: "nav-lobby",
  navClassic: "nav-classic",
  navLadder: "nav-ladder",
  navStealth: "nav-stealth",
  navLeaderboard: "nav-leaderboard",
  navWallet: "nav-wallet",
  navAdmin: "nav-admin",
  logoutBtn: "logout-btn",
  // Landing
  signInGoogleBtn: "sign-in-google-btn",
  // Email/password auth
  authEmailInput: "auth-email-input",
  authPasswordInput: "auth-password-input",
  authNameInput: "auth-name-input",
  authSignInBtn: "auth-signin-btn",
  authSignUpBtn: "auth-signup-btn",
  authSwitchModeBtn: "auth-switch-mode-btn",
  authForgotBtn: "auth-forgot-btn",
  adminLoginLink: "admin-login-link",
  adminLoginBtn: "admin-login-btn",
  // Profile setup
  countryNg: "country-picker-ng",
  countryGh: "country-picker-gh",
  usernameInput: "username-input",
  avatarOption: "avatar-option",
  profileSaveBtn: "profile-save-btn",
  // Wallet
  walletTopupAmount: "wallet-topup-amount",
  walletTopupBtn: "wallet-topup-btn",
  walletWithdrawAmount: "wallet-withdraw-amount",
  walletWithdrawBtn: "wallet-withdraw-btn",
  walletKycBtn: "wallet-kyc-btn",
  kycDocType: "kyc-doc-type",
  kycDocNumber: "kyc-doc-number",
  kycFullName: "kyc-full-name",
  kycSubmitBtn: "kyc-submit-btn",
  // Lobby
  lobbyRoomTab: "lobby-room-tab",
  lobbyMessageInput: "lobby-message-input",
  lobbySendBtn: "lobby-send-btn",
  // Stealth
  stealthQueueBtn: "stealth-queue-btn",
  stealthOptionBtn: "stealth-option-btn",
  stealthSubmitBtn: "stealth-submit-btn",
  // Classic
  classicStartBtn: "classic-start-btn",
  classicOptionBtn: "classic-option-btn",
  // Ladder
  ladderClaimBtn: "ladder-claim-agent-btn",
  ladderAnswerBtn: "ladder-answer-btn",
  ladderIntelBtn: "ladder-intel-btn",
  // Leaderboard
  lbPeriodTab: "lb-period-tab",
  lbModeTab: "lb-mode-tab",
  lbCountryTab: "lb-country-tab",
  // Admin
  adminApproveBtn: "admin-approve-btn",
  adminRejectBtn: "admin-reject-btn",
  adminMuteBtn: "admin-mute-btn",
  adminPinBtn: "admin-pin-btn",
};
